module.exports = __webpack_public_path__ + "static/img/thumb_24.970a5c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_24.png
// module id = 5IkU
// module chunks = 0